import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PrintNode_ds_get_location_by_location_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { location_id: number }): 
  Promise<{ result: { Id?: number, AttachedPrinter?: string, Name?: string } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.location_id)) {
      $missingRequiredInParams.push('\'location_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      location_id: number    }) {
        if(isNil($inParams.location_id)) {
          return true; 
        }
      return false;
    }
}
